import { useEffect, useState } from "react";

export const useAnimatedEllipsis = (
  active = true,
  intervalMs = 400,
): string => {
  const [count, setCount] = useState(1);

  useEffect(() => {
    if (!active) {
      setCount(3);
      return;
    }
    const id = setInterval(() => {
      setCount(prev => (prev % 3) + 1);
    }, intervalMs);
    return () => clearInterval(id);
  }, [active, intervalMs]);

  return active ? ".".repeat(count) : "...";
};
